var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 361,
    viewBox: "0 0 256 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.555 70.7661L232.314 331.126L127.844 360.088L23.6618 331.166L0.444824 70.7661H255.555Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 337.95L212.417 314.547L232.277 92.0571H128V337.95Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.82 155.932H128V123.995H47.917L48.681 132.563L56.531 220.573H128V188.636H85.739L82.82 155.932V155.932ZM90.018 236.542H57.958L62.432 286.688L127.853 304.848L128 304.808V271.58L127.86 271.617L92.292 262.013L90.018 236.542Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1802 0H40.4102V16.035H55.2572V0H71.4882V48.558H55.2582V32.298H40.4112V48.558H24.1812V0H24.1802ZM92.8302 16.103H78.5442V0H123.358V16.103H109.063V48.558H92.8332V16.103H92.8322H92.8302ZM130.47 0H147.393L157.803 17.062L168.203 0H185.133V48.558H168.969V24.49L157.803 41.755H157.523L146.35 24.49V48.558H130.47V0ZM193.21 0H209.445V32.508H232.269V48.558H193.209V0H193.21Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.89 220.573H167.217L163.509 261.993L127.889 271.607V304.833L193.362 286.688L193.842 281.292L201.348 197.212L202.127 188.636H127.89V220.573ZM127.89 155.854V155.932H205.033L205.673 148.754L207.129 132.563L207.892 123.995H127.89V155.855V155.854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.d52b2655beb31b971e5aa2494805cfea.svg";
export { ForwardRef as ReactComponent };